<template>
  <div class="index" id="notice-1">
    <!-- 查看大图模态框 -->
    <div>
      <Modal
        v-model="showFlag"
        :ok-text="ok_text"
        :cancel-text="cancel_text"
        @on-ok="okClick"
        @on-cancel="cancelClick"
      >
        <div slot="header" class="actionBox">
          <!--style="width: 0;border: 0"-->
          <Icon v-if="showIcon" color="#f90" size="30" type="ios-information-circle"/>
          <span style="font-size: 15px;">{{ title }}</span>
        </div>
        <div class="dicon">
          {{ content }}
        </div>
        <div class="attention">
          {{ attention }}
        </div>
      </Modal>

    </div>
  </div>
</template>

<script>
export default {
  name: "index",

  components: {},
  data() {
    return {
      showFlag: false,
      content: '232',
      title: '',
      ok_text: '',
      cancel_text: '',
      attention: '',
      showIcon: true,

    }
  },
  created() {

  },
  mounted() {
    this.$nextTick(() => {
      document.addEventListener('keyup', this.enterKey);
      document.activeElement.blur();
    }, 100)

  },
  methods: {
    okClick() {

    },
    cancelClick() {
      this.okClick()
    },
    // 监听的按钮
    enterKey(event) {
      const code = event.keyCode
        ? event.keyCode
        : event.which
          ? event.which
          : event.charCode
      // eslint-disable-next-line eqeqeq
      if (code == 13 && this.showFlag) {

        this.showFlag = false;
        this.okClick()

      }
    },

  },
  watch: {
    showFlag(val) {
      //   console.log(document.getElementById('dialog_text'))
      //   setTimeout(()=>{
      //     document.getElementById('dialog_text').focus()
      //   })
      //   if(!val){
      this.$el.remove();
      //     document.removeEventListener('keyup', this.enterKey)
      //
      //   }
    }
  }
}
</script>
<style scoped lang="scss">
.actionBox {
  display: flex;
  align-items: center;
}

.dicon {
  width: 100%;
  padding: 0 20px;
  word-break: break-word;
}

.attention {
  width: 100%;
  padding: 0 20px;
  word-break: break-word;
  color: red;
}

</style>



// WEBPACK FOOTER //
// src/components/globalDialog/index.vue